import { SortByPickerValue } from 'components/SortByPIcker';

export const DEFAULT_SORT_OPPORTUNITIES: SortByPickerValue = { sortBy: 'updatedAt', order: 'asc' };
